import { Component, ViewChild } from '@angular/core';
import { MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import type { SwiperOptions } from 'swiper/types/swiper-options';
import { FtSwiperDirective } from 'apps/account/src/account-shared/modules/swiper/ft-swiper.directive';
import { AudienceOnboardService } from "../../services/audience-onboard.service";

@Component({
    selector: 'ft-audience-onboard',
    templateUrl: './audience-onboard.component.html',
    styleUrls: ['./audience-onboard.component.scss'],
    standalone: false
})
export class AudienceOnboardComponent {
    @ViewChild('swiper', { read: FtSwiperDirective }) swiperDir: FtSwiperDirective;
    slideIndex = 0;
    totalSlides = 4;
    slides = Array.from({ length: 4 }, (_, i) => i);
    readonly swiperConfig: SwiperOptions = {
        simulateTouch: false,
        speed: 800,
        allowTouchMove: false,
    };
    dataFileType = 1;
    files: File[] = [];
    error = null;
    loading$ = new Subject<boolean>();
    isUploadComplete = false;


    constructor(public dialogRef: MatDialogRef<any>,
        private audienceOnboardService: AudienceOnboardService) {
    }

    onSlideChange(e: CustomEvent) {
        this.slideIndex = (e as any).detail?.[0]?.realIndex ?? this.slideIndex;
    }

    nextSlide() {
        this.swiperDir?.slideNext();
    }

    goToSlide(idx: number) {
        this.swiperDir?.slideTo(idx);
    }

    onClose() {
        this.dialogRef.close();
    }

    submit() {
        const fileData = this.createFileData();
        this.uploadFile(fileData);
    }

    createFileData(): FormData {
        const data = new FormData();
        this.files.forEach((file) => {
            data.append('formFile', file, file.name);
        });
        return data;
    }

    uploadFile(fileData: FormData) {
        this.loading$.next(true);
        this.error = null;
        this.audienceOnboardService.sendFiles(fileData, this.dataFileType).pipe(
            first(),
        ).subscribe(() => {
            this.loading$.next(false);
            this.isUploadComplete = true;
        }, (err) => {
            this.loading$.next(false);
            this.error = {
                status: err.status,
                message: err.error
            };
        });
    }
}
